import { createSlice } from '@reduxjs/toolkit';

import { isImpactDebugModeEnabled } from '@/domain/impact/utils/is-impact-debug-mode-enabled';
import { getImpactEssQuestions } from '@/domain/impact-ess/actions/get-impact-ess-questions.action';
import { getImpactEssResponses } from '@/domain/impact-ess/actions/get-impact-ess-responses.action';
import {
  EssQuestions,
  EssQuestionValue,
} from '@/domain/impact-ess/entities/question.entity';

export type QuestionsEssState = {
  questions: EssQuestions;
  responses: EssQuestionValue[];
  debugMode: boolean;
};

const initialState: QuestionsEssState = {
  questions: {},
  responses: [],
  debugMode: isImpactDebugModeEnabled(),
};

export const impactEssSlice = createSlice({
  name: 'impactEss',
  initialState,
  reducers: {
    clearImpactAnswers(state) {
      state.questions = {};
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getImpactEssQuestions.fulfilled, (state, action) => {
        state.questions = action.payload;
      })
      .addCase(getImpactEssResponses.fulfilled, (state, action) => {
        state.responses = action.payload;
      });
  },
});
